import { configureStore } from '@reduxjs/toolkit'
import authFormReducer from './reducer/authFormSlice'
import userReducer from './reducer/userSlice'
import newsReducer from './reducer/newsSlice'
import { getDefaultMiddleware } from '@reduxjs/toolkit'

const store = configureStore({
    reducer: {
        authForm: authFormReducer,
        user: userReducer,
        news: newsReducer
    },
    middleware: getDefaultMiddleware({ serializableCheck: false })
});

export default store;